import '.e7{font-size:1.125rem;}.ssr-plugin'
import '.dq{line-height:1.75rem;}.ssr-plugin'
import '.i9{text-decoration:none;}.ssr-plugin'
import '.fb{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e7 dq"
    >
      {translations.privacySubtitle}{' '}
      <a className="i9 fb"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i9 fb"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
